import React, {useEffect} from "react";
import { Button, Typography, Tooltip, IconButton, Stack, Box} from "@mui/material";
import {StyledBaseLineContainer, StyledLeadContainer } from "./Styled/index";
import { useState } from "react";
import { GridRowModes, GridActionsCellItem } from '@mui/x-data-grid';
import CancelIcon from '@mui/icons-material/Close';
import DataGridTable from "./DataGrid";
import CheckIcon from '@mui/icons-material/Check';
import { privateRoutesPath } from "../Routes";
import { useDispatch, useSelector } from "react-redux";
import { requestDeleteApiCall, getLookupType } from "../Utility/apiHelper";
import { useSnackbar } from "notistack";
import { requestShowLoader, requestHideLoader } from "../Store/Global/action";
import { ACTIVE_STATUS, CHILD_DATAGRIDTABLE_HEIGHT, constitutionOfBusinessWidth, fullNameWidth, handleValidateCodevalue,  idWidth,  LEAD_STATUS,  nameWidth,  priceAfterDiscount,  ROWS_TO_VIEW_IN_CHILD_TABLE,  salesOrderStatus, sellingPriceWidth, whocolumnWidth } from "../Utility/constant";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import tableBodyicon from '../Assets/images/tablebody_edit.png'
import tableEditicon from '../Assets/images/tableheader_edit.png';
import disabledEdit from '../Assets/images/disabled_edit.png';
import deleteIcon from '../Assets/images/trashIcon.png';
import disabledDeleteIcon from '../Assets/images/disabledTrashIcon.png';
import LeadDialog from "./LeadDialog";
import TextFiledWithLabel from "./TextFieldWithLabel";
import { discountCalculation } from "../Utility/calculations";
import { useMemo } from "react";
import LeadAccordion from "./LeadAccordion";
import moment from "moment";
import AutoCompleteComponent from "./AutoCompleteComponenet";
import { useIsMobile } from "../Utility/hooks/useIsMobile";
import AddBoxIcon from '@mui/icons-material/AddBox';
import SelectBoxWithLabel from "./SelectBoxWithLable";
import NumericTextField from "./NumericTextfield";
import { emptyAllProducts, requestGetAllActiveProducts } from "../Store/Product/action";
import ProductRecommendationDialog from "./ProductRecommendationDialog";
import ProductViewDialog from "./ProductViewDialog";

const LeadProduct = ({orderstatus = "", accordionLabel="", isOrderproduct= false, isEdit=false,isCustomerProduct = false,customerId,  data = [],inputprice,handlechangeInputprice,handleClearAfterAdded,getProductDetails,
        leadId, handleFilterOption,handleChangerange,pricerange,isViewMode = false, invoiceStatus,showRecommendations = false,recommendationDialogTitle,recommendationButtonLabel,
        selectedproduct, selectedproductData,handleSelectMultiproduct,isInvoice = false,isEditInvoice=false,onRecommendationSave,onRecommendationSecondaryAction,primaryRecommendButtonLabel,
        handleChangeQuantity, selectionModel, setSelectionModel, handlegenerateinvoice, handleviewinvoices, selectedaddedproduct, productQuantity, getDataGridData, handleAddLeadProduct,handleUpdateLeadproduct,
        defaultAccordionOpen = false,fetchRecommendationsUrl,
        showSourceProducts, showRecommendationToggle, secondaryRecommendButtonLabel,
        recommendationInfoText
      }) => {
    const [isBtnDisable, setIsBtnDisable] = useState(false);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [isLoading, setIsLoading] = useState(false);
    // const [selectionModel, setSelectionModel] = React.useState([]);
    const [dataGridData, setDatagridData] = useState([]);
    const [product, setProduct] = useState({
      productType : '',
      productList : []
    });
    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useDispatch();
    const [requiredError, setRequieredError] = useState({
      type: false,
      name: false,
    })
    const location = useLocation();
    const isMobile = useIsMobile();
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const productData = useSelector(state => state?.product?.activeProducts);
    const [isOpenRecommendDialog, setIsOpenRecommendDialog] = useState(false);
    const [productViewDialog, setProductViewDialog] = useState({ open: false, productId: null });
  

    useEffect(() => {
        if(!isEdit) {
            getDataGridData(dataGridData);
        }
        
    },[dataGridData])

    useEffect(() => {
        if (!isEdit && data && data.length > 0) {
            setDatagridData(data);
        }
    }, [data, isEdit]);

    useEffect(() => {
if(isEdit && isCustomerProduct) {
  const filterData = data.map(item => {
    return {
      ...item,
      type: item?.product?.type,
      name: item?.product?.name,
      sellingPrice: item?.sellingPrice,
      productId: item?.product?.id,
      id: item?.id, 
    }
  })
  setDatagridData(filterData);
}

      if(isEdit && !isInvoice && !isOrderproduct && !isCustomerProduct) {
        const filterData = data.map(item => {
          return {
            ...item,
            type: item?.product?.type ,
            name: item?.product?.name,
            sellingPrice: item?.sellingPrice,
            productId: item?.product?.id,
            id: item?.leadProductId,
          }
        })
    
        setDatagridData(filterData);
      }

      if((isEdit && isOrderproduct)) {
        setDatagridData(data);
      }
      if(isEdit && isInvoice) {
        setDatagridData(data)
      }

    },[data])


    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };
    
    const handleSaveClick = (id) => () => {
      setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
    
      const handleDeleteLeadProduct = (id,row) => async() => {
        if(isEdit && isCustomerProduct) {
    dispatch(requestShowLoader());
    const url = `${process.env.REACT_APP_BASE_URL}customerproducts/${id}`;
    const responseData = await requestDeleteApiCall(url);
    if(responseData?.status == 200 || responseData?.status == 204) {
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DELETED_SUCCESSFULLY"), {variant: 'success'});
      dispatch(requestHideLoader());
      getProductDetails(); 
    } else {
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
      dispatch(requestHideLoader());
    }
    return; 
  }
        if(isEdit && isInvoice){
          const invoiceProductId = row?.invoiceProductId
          dispatch(requestShowLoader());
            const url = `${process.env.REACT_APP_BASE_URL}invoice-product/${invoiceProductId}`;
            const responseData =  await requestDeleteApiCall(url);
            if(responseData?.status == 200) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DELETED_SUCCESSFULLY"), {variant: 'success'});
                dispatch(requestHideLoader());
                getProductDetails()
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
                dispatch(requestHideLoader());
            }
        }
        if(isEdit && !isInvoice && !isOrderproduct) {
            dispatch(requestShowLoader());
            const url = `${process.env.REACT_APP_BASE_URL}leadproducts/${id}`;
            const responseData =  await requestDeleteApiCall(url);
            if(responseData?.status == 200|| responseData?.status==204) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DELETED_SUCCESSFULLY"),{variant: 'success'});
                dispatch(requestHideLoader());
                getProductDetails()
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
                dispatch(requestHideLoader());
            }
      
        } 

        if(isEdit && isOrderproduct ) {

            const filterdData = dataGridData?.filter(item => item?.id == id);
            const url = `${process.env.REACT_APP_BASE_URL}sales-order-product/${id}`;
            const responseData =  await requestDeleteApiCall(url);
            if(responseData?.status == 200) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DELETED_SUCCESSFULLY"), {variant: 'success'});
                dispatch(requestHideLoader());
                getProductDetails()
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});
                dispatch(requestHideLoader());
                return true;
            }
        }

        setDatagridData(dataGridData.filter((row) => (row.id !== id )));
        
      };
    
      const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
        const editedRow = dataGridData.find((row) => row.id === id);
        if (editedRow.isNew) {
          setDatagridData(dataGridData.filter((row) => row.id !== id));
        }
      };

     const handleAddProduct = async () => {
  if(product?.productType && selectedaddedproduct?.length > 0) {
    
    const entityId = isCustomerProduct ? customerId : leadId;
    
    if(!isEdit) {
      const addedproductData = selectedaddedproduct.map((item, index) => {
        const price = parseFloat(item?.price || 0);
        const quantity = 1;
        const total = price * quantity;
        
        return {
          ...item,
          quantity: 1,
          unitOfMeasurement: item?.unit,
          sellingPrice: item?.price,
          cGst: item?.cgstRate,
          sGst: item?.sgstRate,
          surchargeRate: item?.surChangeRate,
          
          ...(isCustomerProduct 
            ? { customerId: entityId }  
            : { leadId: entityId }    
          ),
          
          ...(isInvoice
            ? { totalPrice: total }
            : { grossprice: total }
          ),
          
          id: item?.id || index,
          productId: item?.id,
        }
      })

      setDatagridData([...dataGridData, ...addedproductData]);
      handleClearAfterAdded();
      setProduct(prev => ({productList : [], productType: ''}));
    } else {
      if(isOpenDialog?.create){
        handleCloseDialog()
      }
      const isSuccess = await handleAddLeadProduct();
      if (isSuccess) {
        setProduct(prev => ({productList : [], productType: ''}));
      }
    }
    
    setRequieredError({
      type: false,
      name: false,
    })
  } else {
    setRequieredError({
      type: true,
      name: true,
    })
  }
}

      const handleUpdateProduct = (newRecord) => {
        const price = parseFloat(newRecord?.price)*parseFloat(newRecord?.quantity);
        const updatedRecord = (isInvoice && !isEdit) ?   {
          ...newRecord,
          totalPrice: price
        } : {
          ...newRecord,
          grossprice: price
        }

        if(isEdit) {
            if(isOpenDialog?.edit){
              if(isOpenDialog?.quantity <= 0){
                setIsOpenDialog((prev)=>({
                  ...prev,
                  quantityError : true
                }))
                return;
              }
              if(isOpenDialog?.quantity === isOpenDialog?.initialQuantity){
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"),{variant:"info"})
                return;
              }
              handleUpdateLeadproduct(updatedRecord);
              handleCloseDialog()
              return;
            }
            handleUpdateLeadproduct(updatedRecord);
        } else {
          const updatedRow = { ...updatedRecord, isNew: false };
          setDatagridData(dataGridData.map((row) => (row.id === newRecord.id ? updatedRow : row)));
        }

        
      }

      
    const productTableColumn = [
      
        {
            field: 'actions',
            type: 'actions',
            headerName: <img src={tableEditicon} style={{paddingTop: "18px"}} />,
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id ,row}) => {
              const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
      
              if (isInEditMode) {
                return [
                  <GridActionsCellItem
                    icon={<CheckIcon />}
                    label={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    className="textPrimary"
                    onClick={handleSaveClick(id)}
                  />,
                  <GridActionsCellItem
                    icon={<CancelIcon />}
                    label={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                    className="textPrimary"
                    onClick={handleCancelClick(id)}
                    color="inherit"
                  />,
                ];
              }
              return [
                <GridActionsCellItem
                  icon={<img src={(isViewMode) ? disabledEdit : tableBodyicon} />}
                  disabled ={isViewMode}
                  label={handleValidateCodevalue(internationalise,'COMMON_EDIT')}
                  className="textPrimary"
                  onClick={handleEditClick(id)}
                  color="inherit"
                />,
                <GridActionsCellItem
                  icon={<img src={(isViewMode) ? disabledDeleteIcon : deleteIcon} />}
                  disabled ={isViewMode}
                  label={handleValidateCodevalue(internationalise,'COMMON_DELETE')}
                  className="textPrimary"
                  onClick={handleDeleteLeadProduct(id,row)}
                  color="inherit"
                />,
              ];
            },
        },
        { 
            field: 'name', 
            headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_NAME'),
            flex: 1,
            minWidth : fullNameWidth,
            editable: false,
            renderCell: (params) => {
              const targetProductId = params.row?.productId || params.row?.id;
              if (targetProductId) {
                return (
                  <span
                    className="product-link-text"
                    onClick={(e) => {
                      e.stopPropagation();
                      setProductViewDialog({ open: true, productId: targetProductId });
                    }}
                  >
                    {params.value}
                  </span>
                );
              }
              return <span>{params.value}</span>;
            }
        },
        ...((isEdit &&  !(isInvoice || isOrderproduct)) ? 
          [
            { 
            field: 'additionDate', 
            headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_SELLING_DATE'),
            flex: 1,
            minWidth : whocolumnWidth,
            editable: false,
            valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        }
      ]
          : 
          []
        ),
        { 
            field: 'quantity', 
            headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_QTY'), 
            flex: 1,
            minWidth : idWidth,
            editable: true,
            type : 'number',
            align : 'left',
            headerAlign: 'left' 
        },
        { 
            field: 'unitOfMeasurement', 
            headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_UOM'),
            flex: 1,
            minWidth : fullNameWidth,
            editable: false,
            valueGetter:({value})=>{
              if(!value){
                return ""
              }
              return handleValidateCodevalue(internationalise,value)
            }
        },
        { 
            field: 'sellingPrice', 
            headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_SP'),
            flex: 1,
            minWidth : sellingPriceWidth,
            editable: false ,
            renderCell: (cellValues) => {
              return  <span>{Number(cellValues?.row?.sellingPrice).toLocaleString('en')}</span>;
          }
        },
        { 
          field: 'primaryDiscount', 
          headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_PD'),
          flex: 1,
          minWidth : sellingPriceWidth,
          editable: isEdit ? true : false,
      }, 
      { 
          field: 'priceAfterDiscount', 
          headerName:handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT'),
          flex: 1,
            minWidth : priceAfterDiscount,
          editable:false,
      },
        { 
          field: 'cGst', 
          headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_CGST'),
          flex: 1,
          minWidth : idWidth,
          editable: false,
        },
        { 
          field: 'sGst', 
          headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_SGST'),
          flex: 1,
          minWidth : idWidth,
          editable: false,
        },
        { 
          field: 'surchargeRate', 
          headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_SURCHARGE'),
          flex: 1,
          minWidth : nameWidth,
          editable: false,
        },
        {
          field: 'invoicedqty', 
          headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_INV_QTY'),
          flex: 1,
          minWidth : nameWidth,
          editable: false
        },
        {field: 'remainingQty', 
          headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_REM_QTY'),
          flex: 1,
          minWidth : nameWidth,
          editable: false
        },
...(isEdit
    ? [
        { 
          field: 'grandTotal', 
          headerName:handleValidateCodevalue(internationalise,'COMMON_PROD_TP'),
          flex: 1,
          minWidth : sellingPriceWidth,
          editable: false,
        },
      ]
    : []),
    ]


const [openDiscountDialog , setOpenDiscountDialog] = useState(false)
const [discount , setDiscount] = useState({})

const handleOpenEditDiscount=(row)=>{
setOpenDiscountDialog(true)
if(isOrderproduct){
setDiscount({
    ...row,
    "id": row?.id,
    pricePostDiscount : row?.priceAfterDiscount,
    productPrice : row?.productPrice,
    discountAmount : row?.unitDiscountAmount,
    primaryDiscount : row?.primaryDiscount,
    quantity : row?.quantity,
    totalDiscountAmount : row?.discountAmount,
    subTotal : row?.subTotal,
    totalAmount : row?.grandTotal,
    sgst : row?.sGst,
    cgst : row?.cGst,
    surCharge : row?.surchargeRate,
    initialPrimaryDiscount : row?.primaryDiscount,
})
}
if(isInvoice){
  setDiscount({
    ...row,
    pricePostDiscount : row?.priceAfterDiscount,
    productPrice : row?.sellingPrice,
    discountAmount : row?.unitDiscountAmount,
    primaryDiscount : row?.primaryDiscount,
    quantity : row?.quantity,
    totalDiscountAmount : row?.totalDiscount,
    subTotal : row?.subTotal,
    totalAmount : row?.grandTotal,
    sgst : row?.sGst,
    cgst : row?.cGst,
    surCharge : row?.surchargeRate,
    initialPrimaryDiscount : row?.primaryDiscount,
})
}
if(leadId || isCustomerProduct){
  setDiscount({
    ...row,
    "id": row?.id,
    pricePostDiscount : row?.priceAfterDiscount,
    productPrice : row?.sellingPrice,
    discountAmount : row?.unitDiscountAmount,
    primaryDiscount : row?.primaryDiscount,
    quantity : row?.quantity,
    totalDiscountAmount : row?.discountAmount,
    subTotal : row?.subTotal,
    totalAmount : row?.grandTotal,
    sgst : row?.sGst,
    cgst : row?.cGst,
    surCharge : row?.surchargeRate,
    initialPrimaryDiscount : row?.primaryDiscount,
})
}
}

const handleOnChangeDiscount = (event) => {
  const { name, value } = event.target;
  const numValue = value
discountCalculation(setDiscount , discount,name,value,numValue,internationalise,enqueueSnackbar)
};

  const handleSaveDiscount =()=>{                
    if(discount?.initialPrimaryDiscount === discount?.primaryDiscount){
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"),{variant:"info"})
      return;
    }
    else{
      handleUpdateLeadproduct(discount)
      setOpenDiscountDialog(false)
      handleCancelClick(discount?.id)()
    }
  }
  const filteredProductOptions = useMemo(() => {
  if (!product?.productList || !dataGridData) return [];
 if (isCustomerProduct) {
    return product?.productList.filter(item => item.status === "PRODUCT_STATUS_ACTIVE");
  }
  const selectedIds = new Set(dataGridData.map(d => d.productId));

  return product?.productList.filter(item => !selectedIds.has(item.id) && 
      item.status === "PRODUCT_STATUS_ACTIVE"
    );

}, [product?.productList, dataGridData,isCustomerProduct]);

const renderValuesOnCard = [
    { field: "additionDate"},
    { field: "quantity",useLabel : "COMMON_PROD_QTY" },
    { field: "unitOfMeasurement",useLabel:"COMMON_PROD_UOM" },
    { field: "grandTotal" ,useLabel : "COMMON_PROD_TP",type : "currency"}
]

const handleChangeProductType = async(event) => {
    setProduct(prev=>({
      ...prev,
      productType : event.target.value
    }));
    try{
      dispatch(requestShowLoader())
          const queryparams = {
            params: {
              type : event.target.value,
              status : "PRODUCT_STATUS_ACTIVE"
            }
          }
        dispatch(requestGetAllActiveProducts(queryparams));
      }
        catch{
        setProduct(prev=>({
          ...prev,
          productList : []
        }))
        }
        finally{
          dispatch(requestHideLoader())
        }
}
  
          useEffect(() => {
            const updatedLeadTable = (productData ||[]).map((item,index)=>{
              return {
                ...item,
              }
            })
              setProduct(prev=>({
                ...prev,
                productList : updatedLeadTable
              }))
          }, [productData]);
          
        useEffect(() => {
          return () => {
            dispatch(emptyAllProducts());
          };
        }, [dispatch]);

const productStaticType = getLookupType(useSelector(state => state?.lookup?.lookupData),"PRODUCT_TYPE")
    
    const leadStatusData = useSelector(state => state?.lookup?.lookupData)
    ?.find((item) => item?.name == LEAD_STATUS)?.codes
    ?.filter(item => item?.status == ACTIVE_STATUS)
    ?.sort((a,b) => a?.sequence - b?.sequence);

const ProductForm = (
    <React.Fragment>

      <SelectBoxWithLabel
        ownerdropdown = {false}
        disabled = {isViewMode}
        sx={{
          width: isMobile ? "100%" : "auto" 
        }}
        required = {true}
        error={product?.productType ? false : requiredError?.type}
        value={product?.productType}
        label={handleValidateCodevalue(internationalise,'COMMON_PRODUCT_TYPE')}
        handleOnChange={handleChangeProductType}
        optionMenuItem={productStaticType}
        isStatic={false}
      />
                                    
      <AutoCompleteComponent
        multiple
        className={isMobile ? 'mt-15' : ''}
        limitTags={2}
        textInputStyle = {{width:'100% !important' , padding: "7px" }}
        optionSet = {filteredProductOptions}
        value={selectedaddedproduct || null}
        disabled={isViewMode}
        error={selectedaddedproduct?.length > 0 ? false : requiredError?.name}
        required
        label={handleValidateCodevalue(internationalise,'COMMON_PRODUCT_NAME')}
        sx={{width : !isMobile ? '60ch !important' : "100%"}}
        placeholder={handleValidateCodevalue(internationalise,"COMMON_PROD_SELECT_PROD")}
        onChange={(e, newValue) => handleSelectMultiproduct(e, newValue)}
      />

    </React.Fragment>
)
const dialogInitialState = {  create : false,
  edit : false,
  card : null,
  quantity : "",
  initialQuantity : "",
  quantityError : false
}
const [isOpenDialog,setIsOpenDialog] = useState({
...dialogInitialState
})

const handleOnChange = (event) => {
  const {name , value } = event?.target
    setIsOpenDialog((prev) => ({
    ...prev,
    [name]: value
  }));
}

const handleCloseDialog = () => {
  setIsOpenDialog({ 
    ...dialogInitialState
})
}
    return (
        <React.Fragment>
                {/* <StyledSubHeader>
                  {accordionLabel}
                </StyledSubHeader> */}
                <LeadAccordion
                    // label={handleValidateCodevalue(internationalise,'COMMON_DOC_SECTION')} 
                    label={accordionLabel}
                    defaultOpen={defaultAccordionOpen}
                >
                   {!isViewMode && (
                        <StyledBaseLineContainer style={{marginBottom: "20px"}}>
                            {!isMobile && 
                              ProductForm
                            }
                            
                                                    
                            {
                          (!isOrderproduct || 
                          orderstatus == salesOrderStatus?.SO_STATUS_OPEN || 
                          orderstatus == salesOrderStatus?.SO_STATUS_PARTIALLY_INVOICED || 
                          !orderstatus) && 
                          
                          (isMobile ? (
                            <>
                            <Stack
                              className='icon-Container'
                              padding = {"4px 2px"}
                              bgcolor={"#F4F9FE"}
                              display="flex" 
                              gap = {1}
                              justifyContent="center"
                              flexDirection="row" 
                            >
                           <Tooltip
                              title={handleValidateCodevalue(internationalise, 'COMMON_PRODUCT_ADD')}
                              onClick={()=>
                                setIsOpenDialog({
                                  create : true,
                                  edit : false
                                })
                              }
                            >
                              <IconButton>
                                <AddBoxIcon className='followup-icons'/>
                              </IconButton>
                            </Tooltip>
                            </Stack>
                            {isOpenDialog?.create && (
                              <LeadDialog
                                open={isOpenDialog?.create}
                                handleClose={handleCloseDialog}
                                title={accordionLabel}
                                size="sm"
                                btnlabel={handleValidateCodevalue(
                                  internationalise,
                                  "COMMON_ADD"
                                )}
                                handleSave={handleAddProduct}
                              >
                                {ProductForm}
                              </LeadDialog>
                            )}
                            {isOpenDialog?.edit && (
                              <LeadDialog
                                open={isOpenDialog?.edit}
                                handleClose={handleCloseDialog}
                                title={isOpenDialog?.card?.name}
                                size="sm"
                                btnlabel={handleValidateCodevalue(
                                  internationalise,
                                  "COMMON_SAVE"
                                )}
                                handleSave={()=>
                                  handleUpdateProduct({
                                  ...isOpenDialog?.card,
                                  quantity : isOpenDialog?.quantity
                                })
                              }
                              >
                                <Box
                                  display={"flex"} 
                                  justifyContent="center" 
                                  flexDirection={"column"}
                                  gap = {"12px"}
                                >
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_UOM')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.unitOfMeasurement)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_SP')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.sellingPrice)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_PD')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.primaryDiscount)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.priceAfterDiscount)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_CGST')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.cgst)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_SGST')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.sgst)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_SURCHARGE')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.surchargeRate)}
                                />
                              <NumericTextField
                                  sx = {{width: "100% !important"}}
                                  disabled = {isViewMode}
                                  name="quantity"
                                  autoFocus
                                  error = {isOpenDialog?.quantity ? false : isOpenDialog?.quantityError}
                                  label={handleValidateCodevalue(internationalise,'COMMON_PROD_QTY')}
                                  handleOnChange={handleOnChange}
                                  value={isOpenDialog?.quantity}
                              />
                              </Box>
                              </LeadDialog>
                            )}
                            </>
                          ) : (
                            <>
                             <Button
                               variant="contained"
                               className='biztantu-sec-btn'
                               size="medium"
                               name="followupbtn"
                               disabled={isBtnDisable}
                               onClick={handleAddProduct}
                             >
                               {handleValidateCodevalue(internationalise,'COMMON_PRODUCT_ADD')}
                             </Button>
                             {showRecommendations && (
                               <Button
                                 variant="outlined"
                                 className='secondry-edit-btn btn-space'
                                 size="medium"
                                 style={{ marginLeft: "10px"}}
                                 onClick={() => setIsOpenRecommendDialog(true)}
                               >
                                {recommendationButtonLabel}
                               </Button>
                             )}
                            </>
                          ))
                        }
                        </StyledBaseLineContainer>
                    )
                   }

                  {(!isEdit && !isInvoice) &&
                    <DataGridTable 
                        renderValuesOnCard= {renderValuesOnCard}
                        showFilter = {true}
                        columns ={productTableColumn}
                        columnVisibilityModel={{priceAfterDiscount:false, orderId : false , productId : false , remainingQty : false ,invoicedqty: false }}
                        dataGridData = {dataGridData}
                        isLoading={isLoading}
                        isRequiredToolBar={true}
                        isCheckboxReq = {false}
                        rowModesModel={rowModesModel}
                        handleUpdateProduct={handleUpdateProduct}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height={CHILD_DATAGRIDTABLE_HEIGHT}
                        onCellClick={(params, event) => {
                      if (params.field === 'primaryDiscount') {
                        event.stopPropagation();
                        const isEditMode = rowModesModel?.[params.id]?.mode === GridRowModes.Edit;
                          if (isEditMode && isEdit) {
                            handleOpenEditDiscount(params.row);
                          }
                      }
                    }}
                    />
                    }

                   {(isEdit && !isInvoice) && 
                    <DataGridTable 
                        showId={false}
                        showName = {"name"}
                        handleOnClickCard={(card)=>{
                          setIsOpenDialog({
                            create : false,
                            edit : true,
                            card : card,
                            quantity : card?.quantity,
                            initialQuantity : card?.quantity,
                          })
                        }}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height = {CHILD_DATAGRIDTABLE_HEIGHT}
                        renderValuesOnCard={renderValuesOnCard}
                        showFilter = {true}
                        isViewMode = {isViewMode}
                        columns ={productTableColumn}
                        columnVisibilityModel={(orderstatus == salesOrderStatus?.SO_STATUS_COMPLETELY_INVOICED || orderstatus == salesOrderStatus?.SO_STATUS_CANCELLED) ? {actions: false} : isEdit && !isOrderproduct ? {remainingQty : false , invoicedqty : false} : {orderId : false }}
                        dataGridData = {dataGridData}
                        orderstatus={orderstatus}
                        isLoading={isLoading}
                        isRequiredToolBar={true}
                        selectionModel={selectionModel}
                        setSelectionModel={(data) => setSelectionModel(data)}
                        isOrderproduct={isOrderproduct}
                        isCheckboxReq = {isOrderproduct}
                        rowModesModel={rowModesModel}
                        handleUpdateProduct={handleUpdateProduct}
                        handlegenerateinvoice={handlegenerateinvoice}
                        onCellClick={(params, event) => {
                      if (params.field === 'primaryDiscount') {
                        event.stopPropagation();
                        const isEditMode = rowModesModel?.[params.id]?.mode === GridRowModes.Edit;
                          if (isEditMode && isEdit) {
                            handleOpenEditDiscount(params.row);
                          }
                      }
                    }}
                    />
                    }
                    {isInvoice && 
                    <DataGridTable
                        showFilter = {true}
                        columns ={productTableColumn}
                        dataGridData = {dataGridData}
                        columnVisibilityModel= {!isEdit ? {priceAfterDiscount:false,remainingQty:false,invoicedqty : false} : {remainingQty:false,invoicedqty : false}}
                        isLoading={isLoading}
                        isRequiredToolBar={true}
                        isCheckboxReq = {false}
                        rowModesModel={rowModesModel}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height={CHILD_DATAGRIDTABLE_HEIGHT}
                        handleUpdateProduct={handleUpdateProduct}
                       onCellClick={(params, event) => {
                        if (params.field === 'primaryDiscount') {
                          event.stopPropagation();

                          const isEditMode = rowModesModel?.[params.id]?.mode === GridRowModes.Edit;
                          if (isEditMode && isEdit) {
                            handleOpenEditDiscount(params.row);
                          }
                        }
                      }}
                  />}
                    
             {openDiscountDialog &&
                <LeadDialog
                    open = {openDiscountDialog}
                    handleClose = {() => setOpenDiscountDialog(false)}
                    handleSave={handleSaveDiscount}
                    title= {handleValidateCodevalue(internationalise,'COMMON_PROD_ED')}
                    size="sm"
                    btnlabel= {handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                >
                    <StyledLeadContainer sx = {{pb: 2 , mb:2}}>
                    <TextFiledWithLabel
                    className="pricingPopup"
                    disabled={true}
                    label = {handleValidateCodevalue(internationalise,'COMMON_PROD_SP')}
                    value = {discount?.productPrice}
                    />
                    <TextFiledWithLabel
                    className="pricingPopup"
                    disabled={true}
                    label = {handleValidateCodevalue(internationalise,'COMMON_PROD_QTY')}
                    value = {discount?.quantity}
                    />
                    <TextFiledWithLabel
                    className="pricingPopup"
                    disabled={true}
                    name = "priceBeforeDiscount"
                    label ={handleValidateCodevalue(internationalise,'COMMON_SUB_TOTAL')}
                    value = {discount?.subTotal}
                    />
                    </StyledLeadContainer>
                    <StyledLeadContainer  sx = {{pb: 2 , mb:2}}>
                    <TextFiledWithLabel
                    className="pricingPopup"
                    name = "primaryDiscount"
                    label = {handleValidateCodevalue(internationalise,'COMMON_PROD_PD')}
                    value={discount?.primaryDiscount}
                    handleOnChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,3}(\.\d{0,2})?$/.test(value) && value <= 100) {
                          handleOnChangeDiscount(e);
                        }
                    }}
                    />   
                    <TextFiledWithLabel
                    className="pricingPopup"
                    name = "discountAmount"
                    label = {handleValidateCodevalue(internationalise,'COMMON_PROD_DA')}
                    value={discount?.discountAmount}
                    handleOnChange={(e) => {
                        const value = e.target.value;
                        if (/^\d{0,15}(\.\d{0,2})?$/.test(value) && value <= value <= 10 ** 15) {
                          handleOnChangeDiscount(e);
                        }
                    }}
                    />     
                    <TextFiledWithLabel
                    className="pricingPopup"
                    disabled={true}
                    label = {handleValidateCodevalue(internationalise,'COMMON_TOTAL_DISCOUNT')}
                    value = {discount?.totalDiscountAmount}
                    />
                    </StyledLeadContainer>
                    <StyledLeadContainer sx = {{pb: 2 , mb:2}}>
                      <Typography>
                        {handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT')}
                      </Typography>
                    <TextFiledWithLabel
                    className="pricingPopup"
                    disabled={true}
                    name = "pricePostDiscount"
                    // label ={handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT')}
                    value = {discount?.pricePostDiscount}
                    />     
                    </StyledLeadContainer>
                    <StyledLeadContainer>
                      <Typography>
                        {handleValidateCodevalue(internationalise,'COMMON_PROD_TP')}
                      </Typography>
                    <TextFiledWithLabel
                    className="pricingPopup"
                    disabled={true}
                    name = "totalPrice"
                    // label ={handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT')}
                    value={discount?.totalAmount ? discount.totalAmount.toFixed(2) : "0.00"}
                    />     
                    </StyledLeadContainer>
                </LeadDialog>
             }
                
          </LeadAccordion>
          {productViewDialog.open && (
            <ProductViewDialog
              open={productViewDialog.open}
              productId={productViewDialog.productId}
              handleClose={() => setProductViewDialog({ open: false, productId: null })}
            />
          )}
          {isOpenRecommendDialog && (
            <ProductRecommendationDialog
              addedProducts={dataGridData}
              open={isOpenRecommendDialog}
              onClose={() => setIsOpenRecommendDialog(false)}
              url={fetchRecommendationsUrl}
              title={recommendationDialogTitle}
              primaryButtonLabel={primaryRecommendButtonLabel}
              secondaryButtonLabel={
                secondaryRecommendButtonLabel !== undefined
                  ? secondaryRecommendButtonLabel
                  : handleValidateCodevalue(
                      internationalise,
                      "COMMON_PRODUCT_ADD"
                    )
              }
              onPrimaryAction={onRecommendationSave}
              onSecondaryAction={onRecommendationSecondaryAction}
              showSourceProducts={showSourceProducts ?? isCustomerProduct}
              showToggle={showRecommendationToggle ?? isCustomerProduct}
              infoText={recommendationInfoText || "PROD_RECC_INFO"}
            />
          )}
        </React.Fragment>
    )
}

export default LeadProduct;